import { Platform } from "react-native";

export const MAX_WIDTH = 448;
export const MAX_HEIGHT = 932;

//Pass the Dimensions.get("window") object to this function to get the view port size
export const getViewPort = (window: { width: number; height: number }) => {
  if (Platform.OS === "web") {
    return {
      width: window.width > MAX_WIDTH ? MAX_WIDTH : window.width,
      height: window.height > MAX_HEIGHT ? MAX_HEIGHT : window.height,
      isLargeScreen: window.width > MAX_WIDTH || window.height > MAX_HEIGHT,
    };
  }
  return {
    width: window.width,
    height: window.height,
    isLargeScreen: false,
  };
};
